import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ breakpoints }: Theme) =>
  createStyles({
    addButtonYellow: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navCompanyContextActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navCompanyContextActions,
        color: palette.white,
      },
    },
    addButtonGreen: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navAdminActions,
        color: palette.white,
      },
    },
    addButtonBlue: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navOperatorActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navOperatorActions,
        color: palette.white,
      },
    },
    addButtonGray: {
      marginLeft: 5,
      fontSize: 12,
      padding: '5px 10px',
      backgroundColor: palette.navSuperAdminActions,
      color: palette.white,
      '&:hover': {
        backgroundColor: palette.navSuperAdminActions,
        color: palette.white,
      },
    },
    statusContent: {
      color: palette.darkGray,
      paddingLeft: 28,
    },
    addButtonIcon: {
      fontSize: '20px !important',

      '& .MuiButton-PersonAddIcon': {
        marginRight: 2,
      },
    },
    centerItem: {
      color: palette.darkGray,
      fontSize: 12,
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    editOperator: {
      width: 15,
      textAlign: 'center',
    },
    switch: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      display: 'flex',
      width: '15%',
      [breakpoints.down('md')]: {
        width: '20%',
      },
      [breakpoints.down('xs')]: {
        width: '100%',
        justifyContent: 'center',
      },
    },
    listAll: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      margin: '0px 5px',
    },
    listGrid: {
      paddingLeft: 10,
    },
    searchContainer: {
      alignItems: 'center',
      justifyContent: 'space-between',
      [breakpoints.down('sm')]: {
        display: 'flex',
      },
    },

    textField: {
      color: palette.darkGray,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
    dateField: {
      color: palette.darkGray,
      fontSize: 12,
      whiteSpace: 'nowrap',
      '& > div': {
        justifyContent: 'center',
      },
    },
    buttonsGrid: {
      justifyContent: 'space-between',
      display: 'flex',
      width: '13%',
    },
    searchSize: { width: '87%' },
    listButtonSize: { margin: '0px 0px 0px 8px' },
    searchButtonSize: { margin: '0px 8px 0px 0px' },
    refreshButton: { padding: 0, margin: '0px 12px' },
    buttonIsLoading: { backgroundColor: palette.borderGray },
  });
